export default "__VITE_ASSET__Bu46MbWP__"